<template>
  <div  style="width: 100%; height: 100%; display: flex; flex-direction: column"
  class="section-container"
  :class="{'dark':skinType}">
    <div class="section-header">
      <div class="lan"></div>
      <div class="tip4text">总用电量</div>
    </div>
     <te  v-if="source" style="height: 85%; width: 100%" :source="source"></te>
     <no-data-temporarily v-else style="height: 85%; width: 100%"></no-data-temporarily>
  </div>
</template>
<script>

import te from '@/components/realtime-monitoring/ele-situation/utils/te.vue';
import { ele4 } from '@/api/ele-situation/ele3and4';
import NoDataTemporarily from '@/components/utils/no-data-temporarily.vue';
import TurnAskingMixin from '@/mixins/turn-ask';

export default {
  mixins: [TurnAskingMixin],
  data() {
    return {
      source: null,
    };
  },
  props: {
    proId: String,
  },
  components: {
    NoDataTemporarily,
    te,
  },
  watch: {
    proId() {
      this.requestEle5Data();
    },
  },
  mounted() {
    this.requestEle5Data();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    requestEle5Data() {
      if (!this.proId) {
        return;
      }
      ele4({
        ProjectIdStr: this.proId,
      })
        .then((res) => {
          this.source = res;
        })
        .catch(() => {
          this.source = null;
        }).then(() => {
          this.turnAsking({
            routeName: this.routeName,
            nowRouteName: this.$route.name,
            func: this.requestEle5Data,
          });
        });
    },
  },
};
</script>
<style scoped>
.section-header{
  display: flex;
  align-items: center;
  width: 100%;
  height: 14%;
  border-bottom: 0.1rem solid rgb(221, 220, 220);
  position: relative;
}
.lan {
  width: 0.25rem;
  height: 1.5rem;
  background: #2e9bf3;
  position: absolute;
  left: 0.5%;
}
.tip4text {
  font-size: 1.2rem;
  position: absolute;
  left: 1.5%;
}
</style>
